import { event, GtagEvent } from "./event";

export interface PageView extends GtagEvent {
    page_location?:string;
    client_id?:string;
    language?:string;
    page_encoding?:string;
    page_title?:string;
    user_agent?:string;
}
export const page_view = ($_?:PageView) => event('page_view',$_);